/**
 * ProposalCancelAcceptedDialog
 *
 * Diálogo de confirmação para CANCELAR uma proposta já ACEITA.
 *
 * Trata-se de uma ação de exceção: ao cancelar, o negócio volta a permitir
 * edição de produtos/serviços e o link público da proposta é desativado.
 * Por isso o motivo é obrigatório (mínimo de 5 caracteres — mesma validação
 * aplicada no servidor pela RPC `update_proposal_status`).
 *
 * CHANGELOG:
 *   RELEASE: 2026-08-12 v1.1.0 - Passa a ser um wrapper fino de
 *            ProposalStatusReasonDialog (componente genérico reutilizado
 *            também na recusa e no cancelamento comum).
 *   RELEASE: 2026-08-12 v1.0.0 - Criação inicial
 */

import { ProposalStatusReasonDialog } from './ProposalStatusReasonDialog';

interface ProposalCancelAcceptedDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Executa o cancelamento com o motivo informado */
  onConfirm: (reason: string) => void;
  /** Indica processamento em andamento */
  isPending?: boolean;
}

export function ProposalCancelAcceptedDialog({
  open,
  onOpenChange,
  onConfirm,
  isPending = false,
}: ProposalCancelAcceptedDialogProps) {
  return (
    <ProposalStatusReasonDialog
      open={open}
      onOpenChange={onOpenChange}
      onConfirm={onConfirm}
      isPending={isPending}
      title="Cancelar proposta aceita"
      description="Esta proposta já foi aceita pelo cliente. Ao cancelar, ela deixa de valer como documento comercial ativo."
      noticeText="O link público será desativado e os produtos/serviços do negócio voltam a ficar liberados para edição, permitindo gerar uma nova proposta."
      reasonLabel="Motivo do cancelamento"
      reasonPlaceholder="Descreva o motivo do cancelamento (registro de auditoria)"
      confirmLabel="Confirmar cancelamento"
    />
  );
}
